<template>
  <div class="vx-card" id="create-remittance">
    <div class="vx-card__body">
      <form>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              :placeholder="$t('user_displayName')"
              v-model="user_displayName"
              name="user_displayName"
              :label="$t('Creator')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("OriginWarehouse") }}</label>
            <v-select
              label="name"
              name="originWarehouse"
              :options="allWarehouses"
              v-model="TransferModel.storeId"
              v-validate="{
                required: true,
                is_not: TransferModel.destinationStoreInfoCommand.storeId,
              }"
              :reduce="(x) => x.id"
              :disabled="setDisabled"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('originWarehouse')"
              >{{ errors.first("originWarehouse") }}</span
            >
          </div>

          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{
              $t("DestinationWarehouse")
            }}</label>
            <v-select
              label="name"
              name="destinationWarehouse"
              :options="allWarehouses"
              v-model="TransferModel.destinationStoreInfoCommand.storeId"
              v-validate="{ required: true, is_not: TransferModel.storeId }"
              :reduce="(x) => x.id"
              :disabled="setDisabled"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('destinationWarehouse')"
              >{{ errors.first("destinationWarehouse") }}</span
            >
          </div>

          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label datepicker-lb">{{
              $t("CreationDate")
            }}</label>

            <date-picker
              v-model="TransferModel.registerClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              id="date-picker"
              :label="$t('CreationDate')"
              :disabled="setDisabled"
              name="date"
            />

            <span class="text-danger text-sm" v-show="errors.has('date')">{{
              errors.first("date")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Applicant") }}</label>
            <v-select
              label="applicantName"
              name="applicants"
              :options="applicants"
              v-model="TransferModel.applicant"
              disabled="disabled"
              dir="rtl"
            >
            </v-select>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="TransferModel.automationCode"
              name="automationCode"
              :disabled="setDisabled"
              v-validate="'required'"
              :label="$t('AutomationCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('automationCode')"
              >{{ errors.first("automationCode") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Description") }}</label>
            <vs-textarea
              v-model="TransferModel.description"
              name="description"
              :disabled="setDisabled"
              rows="1"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="level1Submit()"
              v-show="showBtn"
              >{{ $t("Continue") }}</vs-button
            >
          </div>
        </div>
      </form>

      <product-attach v-show="showForm"></product-attach>

      <div class="vx-row" v-show="showForm">
        <div class="vx-col w-full">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("Save") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("Reset") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .btns {
  padding: 0.6rem 1.5rem !important;
  float: left;
}
::v-deep .vs-select--label {
  margin-top: 6px;
  margin-bottom: 2px;
  display: block;
}
::v-deep #reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
::v-deep .text-danger {
  position: relative;
  top: -10px !important;
}
::v-deep .v-select {
  margin-bottom: 16px;
}
</style>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import ProductAttach from "./ProductAttach.vue";
import * as moment from "jalali-moment";
import authService from "../../../auth/authService";

const dict = {
  custom: {
    originWarehouse: {
      required: "لطفا نام انبار مبدا را انتخاب نمایید.",
      is_not: "نام انبار مبدا و مقصد نمی تواند یکسان باشد.",
    },
    destinationWarehouse: {
      required: "لطفا نام انبار مقصد را انتخاب نمایید.",
      is_not: "نام انبار مبدا و مقصد نمی تواند یکسان باشد.",
    },
    date: {
      required: "لطفا تاریخ ثبت را انتخاب نمایید.",
    },
    automationCode: {
      required: "لطفا کد اتوماسیون را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_TransferTransactions_Create",
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    ProductAttach,
  },
  data() {
    return {
      user_displayName: "",
      ...mapState({
        model: "transferTransactions/model",
      }),
      showForm: false,
      showBtn: true,
      setDisabled: false,
      TransferModel: {
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        registerClock: "",
        automationCode: null,
        description: null,
        cottageNumber: 0,
        shipmentNumber: "",
        inventoryTransactionItemCommands: [],
        destinationStoreInfoCommand: { storeId: null, storeName: null },
      },
      applicants: [],
      disabled: false,
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
      selectedTransactionSerialsCountLessThanEnteredCount:
        "transferTransactions/selectedTransactionSerialsCountLessThanEnteredCount",
      inventoryTransactions: "transferTransactions/inventoryTransactions",
    }),
  },
  mounted() {
    this.$store.commit("transferTransactions/setModelEmpty");
    this.fetchWarehouses();
    this.calcCurrentTime();
    this.get_displayName();
  },
  methods: {
    async get_displayName() {
      var userInfo = await authService.getUser();
      this.user_displayName = userInfo.profile.nickname;
    },
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
      setModelHeaders: "transferTransactions/setModelHeaders",
      createTransferTransactions: "transferTransactions/create",
    }),
    calcCurrentTime() {
      let todayJalali = moment().locale("fa").format("YYYY-M-D hh:mm:ss");
      this.TransferModel.registerClock = todayJalali;
    },
    level1Submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var Sid = this.TransferModel.storeId;
          var warhouseArr = this.allWarehouses;
          let selectedWarhouse = warhouseArr.find(
            (selectedWarhouse) => selectedWarhouse.id == Sid
          );
          this.TransferModel.storeName = selectedWarhouse.name;

          var destinationSid =
            this.TransferModel.destinationStoreInfoCommand.storeId;
          var warhouseDestinationArr = this.allWarehouses;
          let selectedDestinationWarhouse = warhouseDestinationArr.find(
            (selectedDestinationWarhouse) =>
              selectedDestinationWarhouse.id == destinationSid
          );
          this.TransferModel.destinationStoreInfoCommand.storeName =
            selectedDestinationWarhouse.name;

          this.setModelHeaders(this.TransferModel);

          this.setDisabled = true;
          this.showBtn = false;
          this.showForm = true;
        } else {
          // form have errors
        }
      });
    },
    submitForm() {

      this.$validator.validateAll().then((valid) => {
        if (this.inventoryTransactions.length == 0) {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "برای سند مذکور محصولی انتخاب نگردیده‌است!",
            showConfirmButton: false,
            timer: 5000,
          });
        } else {
          if (valid) {
            this.disabled = true;
            this.createTransferTransactions().then(() => {
              setTimeout(() => {
                this.$router.push("/TransferTransactions/Index");
              }, 3000);
            });
            this.disabled = false;
          } else {
            this.$swal({
              title:
                "تعداد سریال های وارد شده در جدول با سریال های ورودی متفاوت است!",
              type: "info",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "بستن",
            });
            this.disabled = false;
          }
        }
      });
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>
